import { render, staticRenderFns } from "./VehicleMakes.vue?vue&type=template&id=2cde8464&scoped=true"
import script from "./VehicleMakes.vue?vue&type=script&lang=ts"
export * from "./VehicleMakes.vue?vue&type=script&lang=ts"
import style0 from "./VehicleMakes.vue?vue&type=style&index=0&id=2cde8464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde8464",
  null
  
)

export default component.exports